export default __webpack_public_path__ + "static/media/ron-rotter.8c79ff11.png";